// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"5a3af7101792fdfe17b7","127":"29c7e39075801b94f543","293":"241222fac05dff07c128","452":"d08212654f77d86ce627"}[chunkId] + ".js";
};